import { SVGProps } from 'react'

export const ErrorIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      enableBackground="new 0 0 32 32"
      overflow="visible"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <g>
            <circle cx="16" cy="16" id="BG" r="16" fill="#D72828" />
            <path
              d="M14.5,25h3v-3h-3V25z M14.5,6v13h3V6H14.5z"
              fill="#E6E6E6"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
